/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react"
import { Button } from "../ui/button"
import { Label } from "../ui/label"
import { Checkbox } from "../ui/checkbox"
import { Input } from "../ui/input"
import { Radio, Select, Switch, ColorPicker, LucideIcon, getValueByCode, UploadImg, Signature ,UploadFile} from "../ui/ot"

import StarRating from "./star.jsx"; // 請確認路徑正確
import Slider from "./slider.jsx"; // 請確認路徑正確
import RenderDisplayComponent from "./render_display_component"
import { TempDataProvider, useGlobalTempStore } from "./hooks/use_global_temp_store.jsx"
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogFooter } from "../ui/dialog"
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "../ui/card"
// 填寫模式元件渲染
const RenderFillComponent = ({
    canvasMode,
    selectedElement,
    element,
    updateElementContent,
    getCardChildren = () => { },//取得卡片內子元件
    onDropElement,
    CARD_INNER_PADDING = 16,
    mode,   // design / fill /fill_disable
    isEditing,
    setEditingElementId,
    handleMouseDown,
    handleElementClick = () => { },
    setEditingContent,
    // RenderFillComponent,
    // updateElementContent,
    editingContent,
    handleFinishEditing,
    handleResizeMouseDown,
    showBlueBorder,
    handleMouseMove,
    handleResizeMouseMove,
    handleMouseUp,
    handleResizeMouseUp,
    getPageCards = () => { return [] },
    getOrFetchItem = () => { },
    getItem = () => { },
    editableFieldCodes = null,  // null = respect mode; array = only these codes are editable
}) => {
    const [uploadedFiles, setUploadedFiles] = useState({}) // { [elementId]: Array<{ name, type, size, url, contentText? }> }
    const [fileViewerOpen, setFileViewerOpen] = useState(false)
    const [viewingFile, setViewingFile] = useState(null) // { name, type, url, contentText? }
    const [formData, setFormData] = useState({})

    // When editableFieldCodes is provided, only listed codes are editable; otherwise respect mode
    const _modeDisabled = mode === "fill_disable"

    // 當模式為 fill_disable 時，所有互動元件都禁用
    const isDisabledMode = mode === 'fill_disable'
    const safeUpdate = (el, val) => {
        if (isDisabled) return
        updateElementContent(el, val)
    }

    // 將 FileList 讀取為可預覽的資料
    const readFilesForElement = async (element, fileList) => {
        const files = Array.from(fileList || [])
        const readAsTextIfNeeded = (file) => new Promise((resolve) => {
            const type = file.type || ''
            if (type.startsWith('text/') || type === 'application/json') {
                const reader = new FileReader()
                reader.onload = () => resolve({ text: reader.result })
                reader.readAsText(file)
            } else {
                resolve({})
            }
        })

        const results = await Promise.all(files.map(async (file) => {
            const url = URL.createObjectURL(file)
            const extra = await readAsTextIfNeeded(file)
            return { name: file.name, type: file.type, size: file.size, url, contentText: extra.text }
        }))

        setUploadedFiles((prev) => ({
            ...prev,
            [element.id]: element.multiple ? ([...(prev[element.id] || []), ...results]) : results.slice(0, 1)
        }))
        // 同步 formData 顯示檔名或個數
        const names = results.map(r => r.name)
        handleInputChange(element.id, element.multiple ? names : (names[0] || ''))
    }
    const handleInputChange = (elementId, value) => {
        setFormData(prev => ({ ...prev, [elementId]: value }))
    }

    let form_form_column_data = element?.form_form_column_data;
    let form_form_column_data_first = form_form_column_data?.find((_) => true);
    const fieldCode = form_form_column_data_first?.code

    // fill_hidden 計算（不在此處 return，需等 Hooks 全部執行完）
    const fillHidden = form_form_column_data_first?.fill_hidden

    // 欄位層級 fill_disable 三種狀態：
    //   1 / true  → 強制唯讀（後台設為「不可編輯」）
    //   0 / false → 強制可編輯（後台明確設為「可編輯」），不被 editableFieldCodes 覆蓋
    //   undefined / null → 沿用 editableFieldCodes 或 mode 的判斷
    const rawFillDisable = form_form_column_data_first?.fill_disable
    const fieldForceReadonly = rawFillDisable == 1 || rawFillDisable === true
    const fieldForceEditable = rawFillDisable == 0 || rawFillDisable === false

    const isDisabled = fieldForceReadonly
        ? true
        : fieldForceEditable
            ? false
            : (editableFieldCodes != null ? !editableFieldCodes.includes(fieldCode) : _modeDisabled)

    // 唯讀樣式：後台強制唯讀，或 editableFieldCodes 不包含此欄位（但不包含「後台明確設為可編輯」的情況）
    const isPartialEditReadOnly = fieldForceReadonly || (!fieldForceEditable && editableFieldCodes != null && isDisabled)
    //靜態資料
    let form_column_selection_option_data = form_form_column_data_first?.form_column_selection_option_data || [];
    let options = form_column_selection_option_data.map(opt => {
        const selection_option_classify_structure_type_data = opt?.selection_option_classify_structure_type_data || [];
        const selection_option_classify_structure_type_data_first = selection_option_classify_structure_type_data.find(_ => true);
        const name_language_data = selection_option_classify_structure_type_data_first?.name_language_data || [];
        const name_language_data_tw = name_language_data.find(_ => _.language_culture_code === "zh-tw")?.language_culture_value;

        return ({
            label: name_language_data_tw,
            value: opt?.selection_option_id
        });
    });
    //動態資料
    let form_column_source_data = form_form_column_data_first?.form_column_source_data || []
    let form_column_source_data_first = form_column_source_data?.find((_) => true) || null
    let document_source_data = form_column_source_data_first?.document_source_data || []
    let document_source_data_first = document_source_data?.find((_) => true) || null
    let response_data = document_source_data_first?.response_data || []
    let dynamicOptions = response_data.map(item => {
        return {
            label: getValueByCode({ code: "名稱", response_form_value_data: item?.response_form_value_data }),
            value: item?.response_id
        }
    })
    //結合資料
    let finalOptions = options.concat(dynamicOptions);
    // 驗證
    let errorMsg = "";
    const value = element?.content ?? "";
    // 根據已有內容在載入/更新時自動調整 TextArea 高度
    useEffect(() => {
        if (["textarea", "textarea_ocr", "textarea_vernacular"].includes(element?.type)) {
            const el = document.getElementById(`textarea-${element?.id}`)
            if (el) {
                const max = Number(element?.maxHeight ?? 512)
                el.style.height = 'auto'
                const newH = el.scrollHeight
                el.style.height = `${Math.min(newH, max)}px`
                el.style.overflowY = newH > max ? 'auto' : 'hidden'
            }
        }
    }, [element?.id, element?.type, value])

    // fill_hidden：所有 Hook 執行完後，才可以提前 return
    if (fillHidden == 1 || fillHidden === true) return null

    const isRequired = form_form_column_data_first?.is_required === "1";
    // 必填
    if (isRequired && !value) {
        errorMsg = "此欄位為必填";
    }
    // 其他驗證
    const validation = form_form_column_data_first?.form_column_validation_data?.[0];
    if (validation) {
        // 數值驗證
        if (element?.type === "number_input") {
            if (typeof validation.min_value === "number" && Number(value) < validation.min_value) {
                errorMsg = `最小值為 ${validation.min_value}`;
            }
            if (typeof validation.max_value === "number" && Number(value) > validation.max_value) {
                errorMsg = `最大值為 ${validation.max_value}`;
            }
        }
        // 文字長度驗證
        if (
            ["text-content", "textarea", "email_input", "phone_input", "url_input", "password_input"].includes(element?.type)
        ) {
            if (typeof validation.min_text_number === "number" && String(value).length < validation.min_text_number) {
                errorMsg = `最少 ${validation.min_text_number} 字`;
            }
            if (typeof validation.max_text_number === "number" && String(value).length > validation.max_text_number) {
                errorMsg = `最多 ${validation.max_text_number} 字`;
            }
        }
    }

    // 標題 Label 元件
    function RequiredLabel({ children }) {
        return (
            <Label style={{display:"block",fontSize:"12px",color:"#6b7280",fontWeight:400,marginBottom:"3px",whiteSpace:"nowrap",overflow:"hidden",textOverflow:"ellipsis"}}>
                {children}
                {isRequired && !value && <span className="text-red-500 ml-1">*</span>}
            </Label>
        );
    }
    // 部分唯讀模式下，禁用欄位顯示為乾淨的展示字段
    function ReadOnlyFieldDisplay({ label, children }) {
        const display = (children !== '' && children != null) ? children : '—'
        return (
            <div className="w-full flex flex-col pointer-events-auto" style={{padding:"8px 10px"}}>
                <p style={{fontSize:"12px",color:"#6b7280",fontWeight:400,marginBottom:"3px",whiteSpace:"nowrap",overflow:"hidden",textOverflow:"ellipsis",lineHeight:1.4}}>{label}</p>
                <p style={{fontSize:"15px",color:"#111827",fontWeight:600,lineHeight:1.4}}>
                    {display}
                </p>
            </div>
        )
    }
    let form_form_column_data_ = element?.form_form_column_data;
    form_form_column_data_.map((column) => {
        //#region form_calculate先拿資料
        column?.form_column_calculate_data?.forEach((source) => {
            source?.calculate_document_data?.forEach((doc) => {
                // build a sensible filter object if present on source or doc
                const filter = undefined
                // fire-and-forget if not cached yet for this document+filter
                if (!getItem(doc?.document_id, filter)?.response_data) {
                    getOrFetchItem(doc?.document_id, "/utility/response/cache", false, filter)
                }

            })
        })
    })
    //#region 
    switch (element?.type) {
        case "slider": {
            // 取得滑桿設定
            const min = Number(form_form_column_data_first?.min_value ?? 0);
            const max = Number(form_form_column_data_first?.max_value ?? 100);
            const step = Number(form_form_column_data_first?.step ?? 1);
            const thickness = Number(form_form_column_data_first?.thickness ?? 6);
            const value = Number(element?.content ?? min);

            return (
                <div className="flex flex-col w-full h-full  pointer-events-auto"
                    style={{
                        pointerEvents: 'auto',
                    }}>
                    <RequiredLabel>{form_form_column_data_first?.code}</RequiredLabel>
                    <Slider
                        value={value}
                        min={min}
                        max={max}
                        step={step}
                        thickness={thickness}
                        disabled={isDisabled}
                        onChange={val => { if (!isDisabled) updateElementContent(element, val) }}
                    />
                    <p className="text-gray-500 text-xs">{form_form_column_data_first?.help_text}</p>
                    {errorMsg && <p className="text-red-500 text-xs mt-1">{errorMsg}</p>}
                </div>
            );
        }
        case "star":
            return (
                <div className="w-full flex flex-col pointer-events-auto" style={{padding:"8px 10px"}}>
                    <RequiredLabel>{form_form_column_data_first?.code}</RequiredLabel>
                    <StarRating
                        value={Number(value) || 0}
                        max={5}
                        size={28}
                        color="#FFD700"
                        readOnly={isDisabled}
                        onChange={val => { if (!isDisabled) updateElementContent(element, val) }}
                    />
                    {form_form_column_data_first?.help_text && <p className="text-gray-500 text-xs">{form_form_column_data_first?.help_text}</p>}
                    {errorMsg && <p className="text-red-500 text-xs mt-1">{errorMsg}</p>}
                </div>
            );
        case "agreement":
            return (
                <div className="flex items-center w-full h-full  pointer-events-auto">
                    <Checkbox
                        checked={!!value}
                        disabled={isDisabled}
                        onCheckedChange={val => { if (!isDisabled) updateElementContent(element, val) }}
                    />
                    <span className="ml-2">{form_form_column_data_first?.code || "我同意條款"}</span>
                    {errorMsg && <p className="text-red-500 text-xs mt-1">{errorMsg}</p>}
                </div>
            );
        case "verification_code":
            return (
                <div className="flex flex-col items-center w-full h-full pointer-events-auto">
                    <RequiredLabel>{form_form_column_data_first?.code}</RequiredLabel>
                    <Input
                        value={value}
                        disabled={isDisabled}
                        onChange={e => { if (!isDisabled) updateElementContent(element, e.target.value) }}
                        placeholder={form_form_column_data_first?.placeholder}
                    />
                    <Button className="ml-2" disabled={isDisabled}>發送驗證碼</Button>
                    {errorMsg && <p className="text-red-500 text-xs mt-1">{errorMsg}</p>}
                </div>
            );
        case "color_picker":
            return (
                <div className="flex flex-col items-center w-full h-full pointer-events-auto">
                    <RequiredLabel>{form_form_column_data_first?.code}</RequiredLabel>
                    <ColorPicker
                        value={value || "#fff"}
                        disabled={isDisabled}
                        onChange={val => { if (!isDisabled) updateElementContent(element, val) }}
                    />
                    {errorMsg && <p className="text-red-500 text-xs mt-1">{errorMsg}</p>}
                </div>
            );
        case "switch":
            if (isPartialEditReadOnly) return <ReadOnlyFieldDisplay label={form_form_column_data_first?.code}>{value === "1" ? "是" : "否"}</ReadOnlyFieldDisplay>
            return (
                <div className="w-full flex flex-col pointer-events-auto" style={{padding:"8px 10px"}}>
                    <p style={{fontSize:"12px",color:"#6b7280",fontWeight:400,marginBottom:"3px",whiteSpace:"nowrap",overflow:"hidden",textOverflow:"ellipsis",lineHeight:1.4}}>{form_form_column_data_first?.code}</p>
                    <div className="flex items-center mt-0.5">
                        <Switch
                            mode="number"
                            value={value}
                            disabled={isDisabled}
                            onChange={(e) => {
                                if (!isDisabled) updateElementContent(element, e.target.value)
                            }}
                        />
                    </div>
                    {errorMsg && <p className="text-red-500 text-xs">{errorMsg}</p>}
                </div>
            );
        case "text-content":
            if (isPartialEditReadOnly) return <ReadOnlyFieldDisplay label={form_form_column_data_first?.alt ?? form_form_column_data_first?.code}>{value}</ReadOnlyFieldDisplay>
            return (
                <div className="w-full flex flex-col pointer-events-auto" style={{padding:"8px 10px"}}>
                    <p style={{fontSize:"12px",color:"#6b7280",fontWeight:400,marginBottom:"3px",whiteSpace:"nowrap",overflow:"hidden",textOverflow:"ellipsis",lineHeight:1.4}}>{form_form_column_data_first?.alt ?? form_form_column_data_first?.code}</p>
                    <Input
                        className="w-full mt-0.5"
                        placeholder={form_form_column_data_first?.placeholder}
                        value={value}
                        disabled={isDisabled}
                        onChange={e => { if (!isDisabled) updateElementContent(element, e.target.value) }}
                    />
                    {form_form_column_data_first?.help_text && <p className="text-gray-500 text-xs">{form_form_column_data_first?.help_text}</p>}
                    {errorMsg && <p className="text-red-500 text-xs">{errorMsg}</p>}
                </div>
            );
        case "datetime_picker":
            if (isPartialEditReadOnly) return <ReadOnlyFieldDisplay label={form_form_column_data_first?.code}>{value}</ReadOnlyFieldDisplay>
            return (
                <div className="w-full flex flex-col pointer-events-auto" style={{padding:"8px 10px"}}>
                    <p style={{fontSize:"12px",color:"#6b7280",fontWeight:400,marginBottom:"3px",whiteSpace:"nowrap",overflow:"hidden",textOverflow:"ellipsis",lineHeight:1.4}}>{form_form_column_data_first?.code}</p>
                    <Input
                        type="datetime-local"
                        className="w-full mt-0.5"
                        placeholder={form_form_column_data_first?.placeholder}
                        value={value}
                        disabled={isDisabled || form_form_column_data_first?.fill_disable}
                        onChange={e => { if (!isDisabled) updateElementContent(element, e.target.value) }}
                    />
                    {form_form_column_data_first?.help_text && <p className="text-gray-500 text-xs">{form_form_column_data_first?.help_text}</p>}
                    {errorMsg && <p className="text-red-500 text-xs">{errorMsg}</p>}
                </div>
            );

        case "number_input":
            if (isPartialEditReadOnly) return <ReadOnlyFieldDisplay label={form_form_column_data_first?.code}>{value}</ReadOnlyFieldDisplay>
            return (
                <div className="w-full flex flex-col pointer-events-auto" style={{padding:"8px 10px"}}>
                    <p style={{fontSize:"12px",color:"#6b7280",fontWeight:400,marginBottom:"3px",whiteSpace:"nowrap",overflow:"hidden",textOverflow:"ellipsis",lineHeight:1.4}}>{form_form_column_data_first?.code}</p>
                    <Input
                        type="number"
                        className="w-full mt-0.5"
                        placeholder={form_form_column_data_first?.placeholder}
                        value={value}
                        max={form_form_column_data_first?.max_value}
                        min={form_form_column_data_first?.min_value}
                        disabled={isDisabled}
                        onChange={e => { if (!isDisabled) updateElementContent(element, e.target.value) }}
                    />
                    {form_form_column_data_first?.help_text && <p className="text-gray-500 text-xs">{form_form_column_data_first?.help_text}</p>}
                    {errorMsg && <p className="text-red-500 text-xs">{errorMsg}</p>}
                </div>
            );

        case "dropdown": {
            // value 必須是 option 的 value (id)
            if (isPartialEditReadOnly) {
                // prefer option label; fall back to raw value; fall back to '—'
                const matchedLabel = finalOptions.find(o => String(o.value) === String(value))?.label
                const displayLabel = matchedLabel ?? (value !== '' && value != null ? value : null)
                return <ReadOnlyFieldDisplay label={form_form_column_data_first?.code}>{displayLabel}</ReadOnlyFieldDisplay>
            }
            return (
                <div className="w-full flex flex-col pointer-events-auto" style={{padding:"8px 10px"}}>
                    <p style={{fontSize:"12px",color:"#6b7280",fontWeight:400,marginBottom:"3px",whiteSpace:"nowrap",overflow:"hidden",textOverflow:"ellipsis",lineHeight:1.4}}>{form_form_column_data_first?.code}</p>
                    <Select
                        className="w-full mt-0.5"
                        options={finalOptions}
                        value={value || undefined}
                        disabled={isDisabled}
                        onChange={val => { if (!isDisabled) updateElementContent(element, val) }}
                        placeholder={form_form_column_data_first?.placeholder}
                    />
                    {form_form_column_data_first?.help_text && <p className="text-gray-500 text-xs">{form_form_column_data_first?.help_text}</p>}
                    {errorMsg && <p className="text-red-500 text-xs">{errorMsg}</p>}
                </div>
            );
        }
        case "checkbox": {
            // 多選

            // value 是陣列
            const checkedValues = Array.isArray(value) ? value : [];
            return (
                <div className="flex flex-col w-full h-full pointer-events-auto">
                    <RequiredLabel>{form_form_column_data_first?.code}</RequiredLabel>
                    <div className="flex flex-wrap gap-3">
                        {finalOptions.map(option => (
                            <label key={option.value} className="flex items-center gap-2">
                                <Checkbox
                                    checked={checkedValues.includes(option.value)}
                                    disabled={isDisabled}
                                    onCheckedChange={checked => {
                                        if (isDisabled) return
                                        let newValues = checked
                                            ? [...checkedValues, option.value]
                                            : checkedValues.filter(v => v !== option.value);
                                        updateElementContent(element, newValues);
                                    }}
                                />
                                <span>{option.label}</span>
                            </label>
                        ))}
                    </div>
                    {errorMsg && <p className="text-red-500 text-xs mt-1">{errorMsg}</p>}
                </div>
            );
        }
        case "radio_button": {

            return (
                <div className="w-full flex flex-col pointer-events-auto" style={{padding:"8px 10px"}}>
                    <RequiredLabel>{form_form_column_data_first?.code}</RequiredLabel>
                    <Radio.Group
                        value={value}
                        onChange={val => { if (!isDisabled) updateElementContent(element, val) }}
                    >
                        {(finalOptions || []).map(option => (
                            <Radio key={option.value} value={option.value} disabled={isDisabled}>
                                {option.label}
                            </Radio>
                        ))}
                    </Radio.Group>
                    {errorMsg && <p className="text-red-500 text-xs mt-1">{errorMsg}</p>}
                </div>
            );
        }
        case "datetime":
            if (isPartialEditReadOnly) return <ReadOnlyFieldDisplay label={form_form_column_data_first?.code}>{value}</ReadOnlyFieldDisplay>
            return (
                <div className="w-full flex flex-col pointer-events-auto" style={{padding:"8px 10px"}}>
                    <p style={{fontSize:"12px",color:"#6b7280",fontWeight:400,marginBottom:"3px",whiteSpace:"nowrap",overflow:"hidden",textOverflow:"ellipsis",lineHeight:1.4}}>{form_form_column_data_first?.code}</p>
                    <Input
                        type="date"
                        className="w-full mt-0.5"
                        value={value}
                        disabled={isDisabled}
                        onChange={e => { if (!isDisabled) updateElementContent(element, e.target.value) }}
                        placeholder={form_form_column_data_first?.placeholder}
                    />
                    {form_form_column_data_first?.help_text && <p className="text-gray-500 text-xs">{form_form_column_data_first?.help_text}</p>}
                    {errorMsg && <p className="text-red-500 text-xs">{errorMsg}</p>}
                </div>
            );
        case "multi_select_list": {
            return (
                <div className="w-full flex flex-col pointer-events-auto" style={{padding:"8px 10px"}}>
                    <p style={{fontSize:"12px",color:"#6b7280",fontWeight:400,marginBottom:"3px",whiteSpace:"nowrap",overflow:"hidden",textOverflow:"ellipsis",lineHeight:1.4}}>{form_form_column_data_first?.code}</p>
                    <Select
                        className="w-full mt-0.5"
                        mode="multiple"
                        options={finalOptions}
                        value={value === "" ? [] : value}
                        placeholder={form_form_column_data_first?.placeholder}
                        disabled={isDisabled}
                        onChange={(val) => {
                            if (!isDisabled) updateElementContent(element, val)
                        }}
                    />
                    {form_form_column_data_first?.help_text && <p className="text-gray-500 text-xs">{form_form_column_data_first?.help_text}</p>}
                    {errorMsg && <p className="text-red-500 text-xs">{errorMsg}</p>}
                </div>
            );
        }
        case "textarea":
            return (
                <div className="w-full flex flex-col pointer-events-auto" style={{padding:"8px 10px"}}>
                    <p style={{fontSize:"12px",color:"#6b7280",fontWeight:400,marginBottom:"3px",whiteSpace:"nowrap",overflow:"hidden",textOverflow:"ellipsis",lineHeight:1.4}}>{form_form_column_data_first?.alt ?? form_form_column_data_first?.code}</p>
                    <Input.TextArea id={`textarea-${element?.id}`} className="w-full mt-0.5 resize-none max-h-[512px] overflow-y-auto"
                        value={value}
                        disabled={isDisabled}
                        onChange={e => { if (!isDisabled) updateElementContent(element, e.target.value) }}
                        onInput={(e) => {
                            const el = e.target
                            const max = Number(element?.maxHeight ?? 512)
                            el.style.height = 'auto'
                            const newH = el.scrollHeight
                            el.style.height = `${Math.min(newH, max)}px`
                            el.style.overflowY = newH > max ? 'auto' : 'hidden'
                        }}
                        placeholder={form_form_column_data_first?.placeholder}
                    />
                    {form_form_column_data_first?.help_text && <p className="text-gray-500 text-xs">{form_form_column_data_first?.help_text}</p>}
                    {errorMsg && <p className="text-red-500 text-xs">{errorMsg}</p>}
                </div>
            );
        case "textarea_ocr":
            return (
                <div className="w-full flex flex-col pointer-events-auto" style={{padding:"8px 10px"}}>
                    <Button className="mb-1 bg-blue-600 hover:bg-blue-700 text-white self-start" disabled={isDisabled}>
                        文字辨識
                    </Button>
                    <RequiredLabel>{form_form_column_data_first?.code}</RequiredLabel>
                    <Input.TextArea
                        id={`textarea-${element?.id}`}
                        className="w-full resize-none max-h-[320px] overflow-y-auto"
                        value={value}
                        disabled={isDisabled}
                        onChange={e => { if (!isDisabled) updateElementContent(element, e.target.value) }}
                        onInput={(e) => {
                            const el = e.target
                            const max = Number(element?.maxHeight ?? 512)
                            el.style.height = 'auto'
                            const newH = el.scrollHeight
                            el.style.height = `${Math.min(newH, max)}px`
                            el.style.overflowY = newH > max ? 'auto' : 'hidden'
                        }}
                        placeholder={form_form_column_data_first?.placeholder}
                    />
                    {form_form_column_data_first?.help_text && <p className="text-gray-500 text-xs">{form_form_column_data_first?.help_text}</p>}
                    {errorMsg && <p className="text-red-500 text-xs mt-1">{errorMsg}</p>}
                </div>
            );
        case "textarea_vernacular":
            return (
                <div className="w-full flex flex-col pointer-events-auto" style={{padding:"8px 10px"}}>
                    <Button className="mb-1 bg-blue-600 hover:bg-blue-700 text-white self-start" disabled={isDisabled}>
                        白話文解釋
                    </Button>
                    <RequiredLabel>{form_form_column_data_first?.code}</RequiredLabel>
                    <Input.TextArea id={`textarea-${element?.id}`} className="w-full resize-none max-h-[320px] overflow-y-auto"
                        value={value}
                        disabled={isDisabled}
                        onChange={e => { if (!isDisabled) updateElementContent(element, e.target.value) }}
                        onInput={(e) => {
                            const el = e.target
                            const max = Number(element?.maxHeight ?? 512)
                            el.style.height = 'auto'
                            const newH = el.scrollHeight
                            el.style.height = `${Math.min(newH, max)}px`
                            el.style.overflowY = newH > max ? 'auto' : 'hidden'
                        }}
                        placeholder={form_form_column_data_first?.placeholder}
                    />
                    {form_form_column_data_first?.help_text && <p className="text-gray-500 text-xs">{form_form_column_data_first?.help_text}</p>}
                    {errorMsg && <p className="text-red-500 text-xs mt-1">{errorMsg}</p>}
                </div>
            );
        case "email_input":
            return (
                <div className="w-full flex flex-col pointer-events-auto" style={{padding:"8px 10px"}}>
                    <RequiredLabel>{form_form_column_data_first?.code}</RequiredLabel>
                    <Input
                        type="email"
                        className="w-full"
                        value={value}
                        disabled={isDisabled}
                        onChange={e => { if (!isDisabled) updateElementContent(element, e.target.value) }}
                        placeholder={form_form_column_data_first?.placeholder}
                    />
                    {form_form_column_data_first?.help_text && <p className="text-gray-500 text-xs">{form_form_column_data_first?.help_text}</p>}
                    {errorMsg && <p className="text-red-500 text-xs mt-1">{errorMsg}</p>}
                </div>
            );
        case "phone_input":
            return (
                <div className="w-full flex flex-col pointer-events-auto" style={{padding:"8px 10px"}}>
                    <RequiredLabel>{form_form_column_data_first?.code}</RequiredLabel>
                    <Input
                        type="tel"
                        className="w-full"
                        value={value}
                        disabled={isDisabled}
                        onChange={e => { if (!isDisabled) updateElementContent(element, e.target.value) }}
                        placeholder={form_form_column_data_first?.placeholder}
                    />
                    {form_form_column_data_first?.help_text && <p className="text-gray-500 text-xs">{form_form_column_data_first?.help_text}</p>}
                    {errorMsg && <p className="text-red-500 text-xs mt-1">{errorMsg}</p>}
                </div>
            );
        case "url_input":
            return (
                <div className="w-full flex flex-col pointer-events-auto" style={{padding:"8px 10px"}}>
                    <RequiredLabel>{form_form_column_data_first?.code}</RequiredLabel>
                    <Input
                        type="url"
                        className="w-full"
                        value={value}
                        disabled={isDisabled}
                        onChange={e => { if (!isDisabled) updateElementContent(element, e.target.value) }}
                        placeholder={form_form_column_data_first?.placeholder}
                    />
                    {form_form_column_data_first?.help_text && <p className="text-gray-500 text-xs">{form_form_column_data_first?.help_text}</p>}
                    {errorMsg && <p className="text-red-500 text-xs mt-1">{errorMsg}</p>}
                </div>
            );
        case "password_input":
            return (
                <div className="w-full flex flex-col pointer-events-auto" style={{padding:"8px 10px"}}>
                    <RequiredLabel>{form_form_column_data_first?.code}</RequiredLabel>
                    <Input
                        type="password"
                        className="w-full"
                        value={value}
                        disabled={isDisabled}
                        onChange={e => { if (!isDisabled) updateElementContent(element, e.target.value) }}
                        placeholder={form_form_column_data_first?.placeholder}
                    />
                    {form_form_column_data_first?.help_text && <p className="text-gray-500 text-xs">{form_form_column_data_first?.help_text}</p>}
                    {errorMsg && <p className="text-red-500 text-xs mt-1">{errorMsg}</p>}
                </div>
            );
        case "device":
            return (
                <div className="w-full flex flex-col pointer-events-auto" style={{padding:"8px 10px"}}>
                    <LucideIcon name="Table2" className="w-10 h-10 text-gray-400 mx-auto" />
                </div>
            )
        case 'card': {
            // 獲取此群組的子元件
            let childElements = getCardChildren(element?.id) || []

            // 樣式變體
            const variant = element?.cardStyle || 'default'
            let cardCls = 'w-full h-full flex flex-col rounded-md overflow-hidden bg-white border border-border  pointer-events-auto'
            let headerCls = 'pb-3'
            let contentCls = 'pt-3 flex-1 relative min-h-[200px] transition-all'
            let titleNode = (
                <CardTitle className="text-base">{element?.label || '群組標題'}</CardTitle>
            )

            switch (variant) {
                case 'blue-header' || 'default':
                    cardCls = 'w-full h-full flex flex-col rounded-md overflow-hidden bg-white border border-sky-200 shadow-sm  pointer-events-auto'
                    headerCls = 'px-4 py-3 bg-sky-50 border-b border-sky-200'
                    contentCls = 'p-4 flex-1 relative min-h-[200px] transition-all'
                    titleNode = (
                        <div className="flex items-center gap-2">
                            <span className="inline-flex h-6 w-6 items-center justify-center rounded-full bg-sky-100 text-sky-700">
                                <LucideIcon name="Lock" className="h-3.5 w-3.5" />
                            </span>
                            <CardTitle className="text-base font-semibold text-slate-800">{element?.label || '群組標題'}</CardTitle>
                        </div>
                    )
                    break
                case 'outline':
                    cardCls = 'w-full h-full flex flex-col rounded-md overflow-hidden bg-white border border-slate-300 pointer-events-auto'
                    headerCls = 'pb-3 px-4 pt-4'
                    contentCls = 'p-4 flex-1 relative min-h-[200px] transition-all'
                    break
                case 'elevated':
                    cardCls = 'w-full h-full flex flex-col rounded-md overflow-hidden bg-white border border-slate-200 shadow-lg pointer-events-auto'
                    headerCls = 'pb-3 px-4 pt-4'
                    contentCls = 'p-4 flex-1 relative min-h-[200px] transition-all'
                    break
                case 'muted':
                    cardCls = 'w-full h-full flex flex-col rounded-md overflow-hidden bg-slate-50 border border-slate-200 pointer-events-auto'
                    headerCls = 'pb-3 px-4 pt-4 bg-slate-100 border-b border-slate-200'
                    contentCls = 'p-4 flex-1 relative min-h-[200px] transition-all'
                    break
                default:
                    // keep defaults
                    break
            }

            return (
                <Card className={cardCls}>
                    <CardHeader className={headerCls}>
                        {titleNode}
                        {element?.placeholder && (
                            <CardDescription className="text-xs">{element?.placeholder}</CardDescription>
                        )}
                    </CardHeader>
                    <CardContent
                        className={contentCls}
                        style={{
                            backgroundColor: selectedElement?.id === element?.id ? '#eff6ff' : 'transparent',
                            borderWidth: selectedElement?.id === element?.id ? '2px' : '0',
                            borderStyle: 'dashed',
                            borderColor: selectedElement?.id === element?.id ? '#3b82f6' : 'transparent',
                            borderRadius: '8px'
                        }}
                    >
                        <div className="relative w-full h-full">
                            {childElements.map(childElement => {
                                const isChildSelected = selectedElement?.id === childElement.id

                                // get child coordinates (prefer responsive x/y -> legacy)
                                const childX = (childElement?.x != null)
                                    ? (typeof childElement.x === 'object'
                                        ? Number(childElement.x[canvasMode] ?? childElement.x.desktop ?? Object.values(childElement.x)[0] ?? 0)
                                        : Number(childElement.x))
                                    : Number(childElement?.xLegacy ?? 0)

                                const childY = (childElement?.y != null)
                                    ? (typeof childElement.y === 'object'
                                        ? Number(childElement.y[canvasMode] ?? childElement.y.desktop ?? Object.values(childElement.y)[0] ?? 0)
                                        : Number(childElement.y))
                                    : Number(childElement?.yLegacy ?? 0)
                                const showBlueBorder = mode === "design" && selectedElement?.id === childElement?.id;

                                let reconbineElement = { ...childElement };
                                let form_form_column_data = reconbineElement?.form_form_column_data || []
                                let newForm_form_column_data = form_form_column_data.map((column) => {
                                    let newForm_column_source_data = column?.form_column_source_data?.map((source) => {
                                        let newDocument_source_data = source?.document_source_data?.map((doc) => {
                                            // build a sensible filter object if present on source or doc
                                            const filter = column?.form_column_filter_data || []
                                            // fire-and-forget if not cached yet for this document+filter
                                            if (!getItem(doc?.document_id, filter)?.response_data) {
                                                getOrFetchItem(doc?.document_id, "/utility/response/cache", false, filter)
                                            }

                                            return {
                                                ...doc,
                                                response_data: getItem(doc?.document_id, filter)?.response_data || []
                                            }
                                        })
                                        return {
                                            ...source,
                                            document_source_data: newDocument_source_data
                                        }
                                    })
                                    return {
                                        ...column,
                                        form_column_source_data: newForm_column_source_data
                                    }
                                })
                                childElement.form_form_column_data = newForm_form_column_data;
                                return (
                                    (childElements?.hidden !== 1) &&
                                    <div
                                        key={childElement.id}
                                        className={`group absolute transition-all ${isChildSelected ? 'ring-2 ring-blue-400 rounded-md' : ''} border border-dashed border-slate-300 rounded-md bg-white p-2`}
                                        draggable={false}
                                        style={{
                                            left: `${childX}px`,
                                            top: `${childY}px`,
                                            width: childElement?.width ? `${Math.min(childElement.width, element?.width - 50)}px` : 'auto',
                                            ...childElement?.style,
                                        }}
                                        onClick={(e) => {
                                            // e.stopPropagation()
                                            if (mode === "design" && !isEditing) handleElementClick(childElement)
                                            //   onSelectElement(childElement)
                                        }}
                                        // onMouseDown={(e) =>{
                                        //      handleElementMouseDown(e, childElement)
                                        // }}
                                        id={`element-${childElement?.id}`}
                                    >
                                        <div className="cursor-pointer"
                                            style={{
                                                ...childElement?.style,
                                                width: childElement?.width ? `${Math.min(childElement.width, element?.width - 50)}px` : 'auto',
                                                height: childElement?.height ? `${childElement.height}px` : 'auto'
                                            }}
                                        >
                                            {(
                                                // 填寫模式下，表單元件直接顯示可填寫表單
                                                <RenderFillComponent
                                                    getOrFetchItem={getOrFetchItem}
                                                    getItem={getItem}
                                                    element={childElement}
                                                    updateElementContent={updateElementContent}
                                                    mode={mode} // propagate disabled mode to children
                                                />
                                            )}
                                        </div>
                                    </div>
                                )
                            })}
                        </div>
                    </CardContent>
                </Card>
            )
        }
        case 'upload': {
            return (
                <UploadFile
                    element={element}
                    label={form_form_column_data_first?.alt ?? form_form_column_data_first?.code}
                    disabled={isDisabled}
                    defaultValue={value|| null}   // 傳入 file_id 即可自動顯示
                    apiRoute="/component/file"
                    getApi="/utility/file/blob"
                    onConfirm={(fileIdOrIds) => {
                        console.log("Selected file ID(s):", fileIdOrIds);
                        if (!isDisabled) updateElementContent(element, fileIdOrIds);
                    }}
                />
            );
        }
        // case 'upload': {
        //     return (
        //         <div className="space-y-2 w-full pointer-events-auto"  >
        //             {/* 檔案檢視器 */}
        //             <Dialog open={fileViewerOpen} onOpenChange={(open) => { setFileViewerOpen(open); if (!open) setViewingFile(null) }}>
        //                 <DialogContent className="max-w-3xl">
        //                     <DialogHeader>
        //                         <DialogTitle className="truncate">{viewingFile?.name || '檔案預覽'}</DialogTitle>
        //                         <DialogDescription className="truncate">{viewingFile?.type || ''}</DialogDescription>
        //                     </DialogHeader>
        //                     <div className="mt-2 max-h-[70vh] overflow-auto">
        //                         {viewingFile ? (
        //                             viewingFile.type?.startsWith('image/') ? (
        //                                 <img src={viewingFile.url} alt={viewingFile.name} className="max-w-full h-auto mx-auto" />
        //                             ) : viewingFile.type === 'application/pdf' ? (
        //                                 <iframe src={viewingFile.url} title={viewingFile.name} className="w-full h-[70vh] border" />
        //                             ) : (viewingFile.type?.startsWith('text/') || viewingFile.type === 'application/json') ? (
        //                                 <pre className="whitespace-pre-wrap text-sm bg-muted/30 p-3 rounded border">
        //                                     {typeof viewingFile.contentText === 'string' ? viewingFile.contentText : '內容預載中或此檔案無法以文字模式預覽'}
        //                                 </pre>
        //                             ) : (
        //                                 <div className="text-sm text-muted-foreground">
        //                                     此檔案類型暫不支援預覽，您可以下載檔案以查看內容。
        //                                 </div>
        //                             )
        //                         ) : null}
        //                     </div>
        //                     <DialogFooter className="flex items-center justify-between">
        //                         <Button type="button" variant="outline" onClick={() => setFileViewerOpen(false)}>關閉</Button>
        //                         {viewingFile?.url && (
        //                             <a href={viewingFile.url} download={viewingFile.name} className="inline-flex items-center">
        //                                 <Button type="button" variant="default">下載檔案</Button>
        //                             </a>
        //                         )}
        //                     </DialogFooter>
        //                 </DialogContent>
        //             </Dialog>
        //             <Label>
        //                 {form_form_column_data_first?.alt ?? form_form_column_data_first?.code ?? '附件上傳'}
        //                 {element?.required && <span className="text-red-500 ml-1">*</span>}
        //             </Label>
        //             {(() => {
        //                 const inputId = `${element?.id}-file-input`
        //                 const files = uploadedFiles[element?.id] || []
        //                 const canView = !!element?.canView
        //                 return (
        //                     <>
        //                         <div
        //                             className="border-2 border-dashed border-border rounded-lg p-6 text-center hover:bg-muted/50 transition-colors cursor-pointer"
        //                             onClick={() => { if (!isDisabled) document.getElementById(inputId)?.click() }}
        //                             aria-disabled={isDisabled}
        //                         >
        //                             <LucideIcon name="Upload" className="w-10 h-10 mx-auto mb-2 text-muted-foreground" />
        //                             <p className="text-sm text-muted-foreground">{element?.placeholder || '點擊上傳檔案'}</p>
        //                             <input
        //                                 id={inputId}
        //                                 type="file"
        //                                 className="hidden"
        //                                 multiple={!!element?.multiple}
        //                                 disabled={isDisabled}
        //                                 onChange={async (e) => {
        //                                     if (isDisabled) return
        //                                     const fl = e.target.files
        //                                     if (fl && fl.length > 0) {
        //                                         await readFilesForElement(element, fl)

        //                                         e.target.value = '' // 允許同檔再次觸發
        //                                     }
        //                                 }}
        //                             />
        //                         </div>

        //                         {element?.showFileList !== false && files.length > 0 && (
        //                             <div className="mt-2 border rounded-md bg-white divide-y">
        //                                 {files.map((f, idx) => (
        //                                     <div key={idx} className="flex items-center justify-between px-3 py-2 text-sm">
        //                                         <div className="min-w-0 flex-1 mr-2 truncate">
        //                                             <div className="font-medium truncate">{f.name}</div>
        //                                             <div className="text-xs text-muted-foreground truncate">{f.type || '未知類型'} • {(f.size / 1024).toFixed(1)} KB</div>
        //                                         </div>
        //                                         {canView ? (
        //                                             <Button
        //                                                 type="button"
        //                                                 size="sm"
        //                                                 variant="outline"
        //                                                 className="h-7"
        //                                                 disabled={isDisabled}
        //                                                 onClick={() => { if (!isDisabled) { setViewingFile(f); setFileViewerOpen(true) } }}
        //                                                 title="檢視"
        //                                             >
        //                                                 檢視
        //                                             </Button>
        //                                         ) : null}
        //                                     </div>
        //                                 ))}
        //                             </div>
        //                         )}
        //                     </>
        //                 )
        //             })()}
        //         </div>
        //     )
        // }
        case 'signature': {
            return (
                <div className="space-y-2 w-full pointer-events-auto"  >
                    <Label style={{display:"block",fontSize:"12px",color:"#6b7280",fontWeight:400,marginBottom:"3px",whiteSpace:"nowrap",overflow:"hidden",textOverflow:"ellipsis"}}>
                        {form_form_column_data_first?.alt ?? form_form_column_data_first?.code}
                    </Label>
                    <Signature
                        getApi={'/utility/file/blob'}
                        disabled={isDisabled}
                        onConfirm={(data) => { if (!isDisabled) updateElementContent(element, data?.[0]?.data?.file_id?.file_id) }}
                        defaultValue={value ? [{ file_id: value }] : undefined}
                    />
                </div>
            )
        }
        case 'upload_img': {
            return (
                <div className="space-y-2 w-full pointer-events-auto"  >
                    <Label style={{display:"block",fontSize:"12px",color:"#6b7280",fontWeight:400,marginBottom:"3px",whiteSpace:"nowrap",overflow:"hidden",textOverflow:"ellipsis"}}>
                        {form_form_column_data_first?.alt ?? form_form_column_data_first?.code}
                    </Label>
                    <UploadImg
                        api={'/component/file'}
                        getApi={'/utility/file/blob'}
                        disabled={isDisabled}
                        onImagesChange={(data) => { if (!isDisabled) updateElementContent(element, data?.[0]?.data?.file_id?.file_id) }}
                        defaultValue={value ? [{ file_id: value }] : undefined}
                        propsThumbStyle={{
                            height: "",
                            width: "",

                        }}
                    />
                </div>
            )
        }
        case 'image': {
            const imgSrc = (element?.images && element?.images.length > 0) ? element?.images[0] : (element?.imageUrl || '')
            const boxHeight = typeof element?.size?.height === 'number' ? element?.size.height : undefined
            const isCarousel = !!element?.enableCarousel && (element?.images?.length || 0) > 1
            return (
                <div className="space-y-1.5 w-full pointer-events-auto">
                    <Label className="text-sm">{element?.label || '圖片'}</Label>
                    <div className="border rounded-lg bg-white overflow-hidden relative" style={{ height: boxHeight }}>
                        {imgSrc ? (
                            <img
                                src={imgSrc}
                                alt={element?.altText || element?.label || '圖片'}
                                style={{ width: '100%', height: '100%', objectFit: element?.objectFit || 'cover' }}
                                loading={element?.lazyLoad === false ? 'eager' : 'lazy'}
                                onError={(e) => {
                                    if (element?.errorImage && e.currentTarget.src !== element?.errorImage) {
                                        e.currentTarget.src = element?.errorImage
                                    }
                                }}
                            />
                        ) : (
                            <div className="p-8 bg-muted/20 h-full flex items-center justify-center">
                                <LucideIcon name="ImageIcon" className="w-12 h-12 text-muted-foreground" />
                            </div>
                        )}
                        {isCarousel && (
                            <>
                                {element?.carouselShowArrows !== false && (
                                    <div className="pointer-events-none absolute inset-0 flex items-center justify-between px-2">
                                        <div className="pointer-events-auto inline-flex items-center justify-center h-7 w-7 rounded-full bg-black/40 text-white">
                                            <LucideIcon name="ChevronLeft" className="h-4 w-4" />
                                        </div>
                                        <div className="pointer-events-auto inline-flex items-center justify-center h-7 w-7 rounded-full bg-black/40 text-white">
                                            <LucideIcon name="ChevronRight" className="h-4 w-4" />
                                        </div>
                                    </div>
                                )}
                                {element?.carouselShowIndicators !== false && (
                                    <div className="absolute bottom-2 left-1/2 -translate-x-1/2 flex gap-1">
                                        {element?.images.map((_, i) => (
                                            <span key={i} className={`h-1.5 w-1.5 rounded-full ${i === 0 ? 'bg-white' : 'bg-white/50'}`}></span>
                                        ))}
                                    </div>
                                )}
                            </>
                        )}
                        {element?.showCaption && !!element?.caption && (
                            <div className="text-xs text-muted-foreground px-3 py-2 border-t bg-muted/10">
                                {element?.caption}
                            </div>
                        )}
                    </div>
                </div>
            )
        }
        case 'button': {
            return (
                <div className="w-full space-y-1.5 pointer-events-auto">
                    <Button
                        variant={element?.buttonVariant || 'default'}
                        className={element?.isFullWidth ? "w-full" : ""}
                        size={element?.buttonSize}
                        disabled={isDisabled}
                    >
                        {element?.label || '按鈕'}
                    </Button>

                </div>
            )
        }
        default:
            return <RenderDisplayComponent element={element} />;
    }
}
export default RenderFillComponent;
